<template>
  <div class="sitebuilder-element-container"
       element="IframeComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile" :id="id"
       :config-properties="JSON.stringify(internal_config)"
       v-on:click="focusElement($event)"
       @contextmenu.prevent="handler($event)"
       :style="style()"
	   ref="iframe_component_container">
    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)"
                             v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" ref="draggableResizable"
                             :draggable="false" :enable-native-drag="true">
			<rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
			<sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-IframeComponent'></options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>
      <div class="embed-responsive embed-responsive-16by9" :class="{ 'auto-resize-height': autoResizeHeight }" ref="container_iframe"
           v-bind:style="{height : height, width : width, minHeight : minHeight}">
        <iframe :width="internal_config.width" :height="internal_config.height" ref="iframe"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="embed-responsive-item"
                v-bind:style="{'border-radius': radius,border : border}">
        </iframe>
      </div>
      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>
<script>

	import Model from './Model';
	import Resources from './Resources.vue';
  import OptionsElementBar from "../OptionsElementBar";

	export default {
		name: 'IframeComponent',
		components: {
      OptionsElementBar,
			Resources,
		},
		props: ['config', 'height_start', 'device', 'id', 'preview'],
		data() {
			return {
				...Model.data(),
				autoResizeHeight: false
			}
		},
		computed: {
			width() {
				return this.internal_config.width;
			},
			minHeight() {
				return this.internal_config.minHeight;
			},
			height() {
				return this.internal_config.height;
			},
			border() {
				return this.internal_config.border;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
		},
		watch: {
			'internal_config': {
				deep: true,
				handler(value) {
					this.$eventHub.setValueElementConfig(this.id, value);
					this.$eventPointer.log(this.id, value);
				}
			},
		},

		methods: {
			animation() {
				return true;
			},

			onResize: function (x, y, width, height) {
				this.internal_config.width = width + 'px';
				this.internal_config.height = height + 'px';

				this.$refs.resourcesData.setValuesData(this);
			},

			focusElement(e) {
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this);

				e.stopPropagation();
				e.preventDefault();
			},
			showResources() {
				return this.$refs.resourcesData.getValuesData();
			},

			//change order on html
			changeOrderPanel(elem, idx) {
				if (typeof this.$parent.changeOrderPanel !== 'undefined') {
				this.$parent.changeOrderPanel(this, idx);
				} else {
				this.$parent.$parent.changeOrderPanel(this, idx);
				}
			},
			handler: function (e) {
				// this.$el.classList.add('animated', 'jello', 'infinite');
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this, true);
				e.stopPropagation();
				e.preventDefault();
			},
			style() {

				let style = `left:  ${this.internal_config.left};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
				return style;
			},
			buildIframe: function () {
				const iframe = this.$refs.iframe;
				iframe.src = '';
				try {
					const doc = iframe.contentWindow.document;
					doc.open();
					doc.write(this.internal_config.content);
					doc.close();
				} catch (e) {
					console.log(e);
				}

				if (this.internal_config.src != '') {
					iframe.src = this.internal_config.src;
				} else if (this.internal_config.content != '') {
					try {
						const doc = iframe.contentWindow.document;
						doc.open();
						doc.write(this.internal_config.content);
						doc.close();
					} catch (e) {
						if (e && e.name === 'SecurityError') {
							iframe.src = 'about:blank';
							iframe.onload = () => {
								iframe.onload = null;
								try {
									const doc = iframe.contentWindow.document;
									doc.open();
									doc.write(this.internal_config.content);
									doc.close();
								} catch (err) {
									console.warn(err);
								}
							};
						} else {
							throw e;
						}
					}
				}

				if (this.internal_config.fullWidth) {
					this.$el.classList.add('full-width-element');
				} else {
					this.$el.classList.remove('full-width-element');
				}


				//RESET HEIGHT TO ORIGINAL FROM SETTINGS
				this.$refs.iframe.style.removeProperty('height')
				this.$refs.iframe.height = this.internal_config.height;
				this.$refs.resourcesData.setValuesData(this);
				
				const container_iframe = this.$refs.container_iframe;
				if(container_iframe){
					container_iframe.style.height = this.internal_config.height;

					//RESET CONTENT TO RELOAD OR BLANK
					if((!(this.internal_config.src != '') &&
					!(this.internal_config.content != '')) && (
					!this.internal_config.border || 
					this.internal_config.border.substring(0,1) == '0')){
						container_iframe.style.border = '1px dotted #333333';
					} else {
						container_iframe.style.border = '0 none #000000';
					} 
				}

				const draggableResizable = this.$refs.draggableResizable
				if(draggableResizable && draggableResizable.$el.style){
					draggableResizable.$el.style.removeProperty('height')
					//draggableResizable.style.height = this.internal_config.height;
				}

				const iframeComponentContainer = this.$refs.iframe_component_container
				if(iframeComponentContainer){
					iframeComponentContainer.style.height = this.internal_config.height;

					const containerParent = iframeComponentContainer.parentElement;
					if (containerParent) {
						containerParent.style.height = JSON.parse(containerParent.getAttribute('config-properties')).height;

						const containerParentParent = containerParent.parentElement;
						if (containerParentParent) {
							containerParentParent.style.height = JSON.parse(containerParentParent.getAttribute('config-properties')).height;
						}
					}
				}
				 
				this.autoResizeHeight = false;
				try{
					const disable_auto_height = new URL(this.internal_config.src).searchParams.get('disable_auto_height');
					if(disable_auto_height == '1'){
						this.autoResizeHeight = false;
					} else {
						window.addEventListener('message', this.handleAutoHeight, false);
					}
				} catch (e){
                    console.log(e)
				}
			},
			handleAutoHeight(event) {

				if (event.data && event.data.frameHeight) {

					this.autoResizeHeight = true;
					
					const iframeContentHeight = event.data.frameHeight+20;

      				const iframe = this.$refs.iframe;
					if(iframe){
						iframe.style.height = (iframeContentHeight)+'px';
						iframe.height = (iframeContentHeight)+'px';
					}

					const container_iframe = this.$refs.container_iframe;
					if(container_iframe){
						container_iframe.style.height = (iframeContentHeight)+'px';
					}

					const draggableResizable = this.$refs.draggableResizable
					if(draggableResizable){
						draggableResizable.style.height = (iframeContentHeight)+'px';
					}

					const iframeComponentContainer = this.$refs.iframe_component_container
					if(iframeComponentContainer){
						iframeComponentContainer.style.height = (iframeContentHeight)+'px';

						const containerParent = iframeComponentContainer.parentElement;
						if (containerParent) {

							if(parseFloat(containerParent.style.height) < (iframeContentHeight)){
								containerParent.style.height = (iframeContentHeight+10)+'px';
							}

							const containerParentParent = containerParent.parentElement;
							if (containerParentParent && (parseFloat(containerParentParent.style.height) < (iframeContentHeight))){
								containerParentParent.style.height = (iframeContentHeight+10)+'px';
							}
						}
					}
				}
			},
		},
		mounted() {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);

			this.internal_config = config;
			this.device = device;

			if (typeof id !== 'undefined') {
				this.id = id;
			}

			this.internal_config = window.mergeRecursive(this.props, this.$props.config);

			if (this.$props.preview) {
				this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
			}
			this.$root.$on('setConfigElement', (id, obj) => {
				if(this.id == id){
				this.config = obj;
				this.internal_config = obj;
				}
			});

			this.buildIframe();

			let objIds = [];
			$('[id]').each(function () {
				var ids = $('[id="' + this.id + '"]');
				if (ids.length > 1 && ids[0] == this && parseInt(this.id))
					objIds.push(this.id);
			});
			if (objIds.includes(this.id)) {
				this.id = Date.now() + parseInt(Math.random() * 10000);
			}

			this.$refs.resourcesData.setValuesData(this);
		}
	}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .vdr {
    height: auto !important;
  }

  [data-device="desktop"] .embed-responsive {
    min-height: unset !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Iframe/Iframe.vue